import { render, staticRenderFns } from "./OrderSummaryRow.vue?vue&type=template&id=6fca96cb&scoped=true"
import script from "./OrderSummaryRow.vue?vue&type=script&lang=ts"
export * from "./OrderSummaryRow.vue?vue&type=script&lang=ts"
import style0 from "./OrderSummaryRow.vue?vue&type=style&index=0&id=6fca96cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fca96cb",
  null
  
)

export default component.exports